// GooseBerry Reflective Scanner, predefined design methods, design phase, fidelity options.
export const DESIGN_PHASES = [
  "Research",
  "Ideation",
  "Concept",
  "Prototype",
  "Testing",
  "Implementation",
];

export const DATABASE_TYPES = [
  "General research notes",
  "Interview transcripts",
  "Survey results",
  "Personas",
  "Field observations",
  "Literature summary",
];

export const FIDELITY_LEVELS = [
  {
    id: "low",
    label: "Low fidelity",
    hint: "Sketches, paper prototypes, rough wireframes.",
  },
  {
    id: "mid",
    label: "Mid fidelity",
    hint: "Wireframes with structure and basic interaction.",
  },
  {
    id: "high",
    label: "High fidelity",
    hint: "Detailed visual design close to final UI.",
  },
];

export const PREDEFINED_METHODS = [
  {
    id: "crazy-8",
    name: "Crazy 8",
    stage: "Ideation",
    description: "Rapid ideation method where 8 ideas are generated quickly to stimulate divergence and quantity.",
    recognition: "A single sheet divided into 8 quick sketches of alternative directions.",
    evaluationFocus: "Quantity and divergence; does it explore meaningfully different directions?",
    failureModes: ["Ideas too similar", "Premature convergence", "Unclear problem framing"],
  },
  {
    id: "brainstorming",
    name: "Brainstorming",
    stage: "Ideation",
    description: "Open idea generation without evaluation in the early phase.",
    recognition: "Lists of ideas, sticky notes, mind maps.",
    evaluationFocus: "Range, inclusivity of voices, absence of premature judgement.",
    failureModes: ["Dominated by one voice", "Evaluation leaks in", "Ignoring marginalized perspectives"],
  },
  {
    id: "co-design",
    name: "Co-design",
    stage: "Ideation",
    description: "Collaborative design with stakeholders or end users.",
    recognition: "Participants actively shaping outputs; shared artifacts.",
    evaluationFocus: "Power-sharing; whose decisions shaped the final outcome?",
    failureModes: ["Token participation", "Missing under-represented groups", "Designers overriding lived expertise"],
  },
  {
    id: "storyboard",
    name: "Storyboard",
    stage: "Concept",
    description: "Sequence used to illustrate an experience or service journey.",
    recognition: "Panels showing actions, moments, emotions, and context.",
    evaluationFocus: "Narrative clarity; inclusion of edge cases and failure moments.",
    failureModes: ["Happy path only", "Missing accessibility moments", "Unclear transitions"],
  },
  {
    id: "customer-journey",
    name: "Customer Journey",
    stage: "Research",
    description: "Stepwise mapping of user experience across touchpoints.",
    recognition: "Phases, touchpoints, emotions, opportunities across a timeline.",
    evaluationFocus: "Coverage of phases; evidence behind emotions; fairness across user groups.",
    failureModes: ["One persona journey generalized", "Assumed emotions", "Missing invisible backstage work"],
  },
  {
    id: "wireframe",
    name: "Wireframe",
    stage: "Prototype",
    description: "Low-fidelity structural representation of an interface.",
    recognition: "Monochrome blocks, placeholders, clear hierarchy over visual polish.",
    evaluationFocus: "Information hierarchy, primary actions, critical paths.",
    failureModes: ["Visual decisions creeping in", "Missing empty/error states", "Desktop-only thinking"],
  },
  {
    id: "service-blueprint",
    name: "Service Blueprint",
    stage: "Concept",
    description: "Frontstage/backstage process map of a service.",
    recognition: "Swimlanes for user actions, frontstage, backstage, supporting processes.",
    evaluationFocus: "Dependencies, handoffs, failure points, invisible work.",
    failureModes: ["Backstage gaps", "Missing partners", "Unlabeled responsibilities"],
  },
];
